import { Button, styled } from '@mui/material';

const SocialButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontSize: '0.875rem',
  boxShadow: theme.shadows[1],
  backgroundColor: theme.palette.common.white,
  color: theme.palette.common.black,
  transition: 'background-color 0.5s',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
    transition: 'background-color 0.5s',
    cursor: 'pointer',
  },
}));

const ButtonText = styled('p')(({ theme }) => ({
  textAlign: 'center',
  marginLeft: theme.spacing(),
}));

export { SocialButton, ButtonText };
